import request from "@/utils/request";
export function getData(data) {
  return request({
    url: "/icps/system/sign/intelligent/materials/model/getList",
    method: "post",
    data,
  });
}
export function saveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/intelligent/materials/model/saveOrUpdate",
    method: "post",
    data,
  });
}

export function getList(data) {
  return request({
    url: "/icps/system/sign/basics/namingRule/getListByTypeId",
    method: "post",
    data,
  });
}